import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mapings = new Map<ProfiBazaAPIModels.UserManualAdministrativeType, string>([
	[ProfiBazaAPIModels.UserManualAdministrativeType.Global, 'Globalny'],
	[ProfiBazaAPIModels.UserManualAdministrativeType.Local, 'Lokalny'],
]);

export const map = (value: ProfiBazaAPIModels.UserManualAdministrativeType): string =>
	mapings.get(value) ?? '';
